import React from "react";
import { Chip } from "@mui/material";
import {
  CheckCircle,
  Cancel,
  Pending,
  AccessTime,
  Error,
  Warning,
} from "@mui/icons-material";

/**
 * Reusable StatusChip component with standardized status mapping
 * 
 * @param {string} status - Status value (pending, approved, rejected, active, inactive, etc.)
 * @param {string} label - Custom label (optional, defaults to status)
 * @param {string} size - Chip size (small, medium)
 * @param {Object} sx - Custom styles
 */
const StatusChip = ({
  status,
  label,
  size = "small",
  sx = {},
}) => {
  const statusConfig = {
    // Approval statuses
    pending: {
      color: "warning",
      icon: <Pending />,
      label: "Pending",
    },
    approved: {
      color: "success",
      icon: <CheckCircle />,
      label: "Approved",
    },
    rejected: {
      color: "error",
      icon: <Cancel />,
      label: "Rejected",
    },
    // Active/Inactive
    active: {
      color: "success",
      icon: <CheckCircle />,
      label: "Active",
    },
    inactive: {
      color: "default",
      icon: <Cancel />,
      label: "Inactive",
    },
    // Assignment statuses
    submitted: {
      color: "info",
      icon: <Pending />,
      label: "Submitted",
    },
    graded: {
      color: "success",
      icon: <CheckCircle />,
      label: "Graded",
    },
    overdue: {
      color: "error",
      icon: <Error />,
      label: "Overdue",
    },
    // Leave statuses
    cancelled: {
      color: "default",
      icon: <Cancel />,
      label: "Cancelled",
    },
    // Attendance statuses
    present: {
      color: "success",
      icon: <CheckCircle />,
      label: "Present",
    },
    absent: {
      color: "error",
      icon: <Cancel />,
      label: "Absent",
    },
    late: {
      color: "warning",
      icon: <AccessTime />,
      label: "Late",
    },
    leave: {
      color: "warning",
      icon: <AccessTime />,
      label: "Leave",
    },
    on_leave: {
      color: "success",
      icon: <CheckCircle />,
      label: "Present",
    },
    // Generic
    success: {
      color: "success",
      icon: <CheckCircle />,
      label: "Success",
    },
    error: {
      color: "error",
      icon: <Error />,
      label: "Error",
    },
    warning: {
      color: "warning",
      icon: <Warning />,
      label: "Warning",
    },
  };

  const config = statusConfig[status?.toLowerCase()] || {
    color: "default",
    icon: null,
    label: status || "Unknown",
  };

  return (
    <Chip
      label={label || config.label}
      size={size}
      color={config.color}
      icon={config.icon}
      sx={{
        textTransform: "capitalize",
        fontWeight: 500,
        maxWidth: "none",
        "& .MuiChip-label": { whiteSpace: "nowrap", overflow: "visible", textOverflow: "clip" },
        ...sx,
      }}
    />
  );
};

export default StatusChip;

